import React, { useEffect, useRef, useState } from "react";
import { API_URL } from "../../../constants/appConfig";
import myToast from "../../../components/toast";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  CircularProgress,
  Divider,
  Alert,
  Grid,
} from "@mui/material";
import { AddPhotoAlternate as AddPhotoIcon } from "@mui/icons-material";
import heic2any from "heic2any";

const Index = () => {
  const [savingProduct, setSavingProduct] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [image, setImage] = useState();
  const [imageBase64Data, setImageBase64Data] = useState();
  const [visible, setVisible] = useState(false);
  const [carat, setCarat] = useState(null);
  const [carats, setCarats] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [productGram, setProductGram] = useState(null);
  const [gainMilyem, setGainMilyem] = useState(null);
  const [productName, setProductName] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const navigate = useNavigate();

  const fileInputRef = useRef(null); // useRef ile bir referans oluşturuluyor

  const triggerFileInput = () => {
    fileInputRef.current.click(); // Butona tıklandığında dosya seçme inputunu tetikletiyoruz
  };

  const getAllCategory = async () => {
    try {
      const API =
        API_URL + "/category/getAllCategoryByCurrency" + "?currency=true";
      const response = await fetch(API);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getAllCarat = async () => {
    try {
      const API = API_URL + "/carat/getAllCarat";
      const response = await fetch(API);
      const data = await response.json();
      setCarats(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleSelectCategory = (selectedCategory) => {
    const categoryId = selectedCategory.categoryId;
    const API =
      API_URL +
      "/subCategory/getSubCategoryByCategoryId" +
      "?categoryId=" +
      categoryId;
    fetch(API)
      .then((response) => response.json())
      .then((data) => {
        setSubCategories(data);
      });
    setCategory(selectedCategory);
  };
  const handleSelectSubCategory = (selectedSubCategory) => {
    setSelectedSubCategory(selectedSubCategory);
  };

  useEffect(() => {
    setLoading(true);
    getAllCategory();
    getAllCarat();
    setLoading(false);
  }, []);

  const saveProduct = async (data) => {
    const API = API_URL + "/product/saveProduct";
    const response = await fetch(API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  };

  const handleSaveProduct = async () => {
    if (!productName) {
      myToast({ status: "warn", message: "Ürün adı boş olamaz" });
      return;
    } else if (!carat) {
      myToast({ status: "warn", message: "Ayar seçimi yapınız" });
      return;
    } else if (!gainMilyem) {
      myToast({ status: "warn", message: "Kazanç milyemi boş olamaz" });
      return;
    } else if (!productGram) {
      myToast({ status: "warn", message: "Gram boş olamaz" });
      return;
    } else if (!category.categoryId) {
      myToast({ status: "warn", message: "Kategori seçimi yapınız" });
      return;
    } else if (!image) {
      myToast({ status: "warn", message: "Resim seçimi yapınız" });
      return;
    } else {
      try {
        setSavingProduct(true);
        const productData = {
          productName: productName,
          productDescription: productDescription,
          productCaratFk: {
            caratId: carat,
          },
          productGainMilyem: gainMilyem,
          productGram: productGram,
          productVisible: visible ? true : false,
          productCategoryFk: {
            categoryId: category.categoryId,
            currency: true,
          },
          productSubCategoryFk: selectedSubCategory
            ? { subcategoryId: selectedSubCategory.subcategoryId }
            : null,
          imageBase64Data: imageBase64Data,
          productGold: true,
        };

        const response = await saveProduct(productData);
        if (response?.productId) {
          myToast({ status: "success", message: "Ürün başarıyla eklendi" });
          navigate("/products");
        } else {
          myToast({
            status: "error",
            message: "Ürün eklenirken hata oluştu",
          });
        }
      } catch (error) {
        myToast({ status: "error", message: "Ürün eklenirken hata oluştu" });
      }
      setSavingProduct(false);
    }
  };

  const handleFileUpload = async (event) => {
    try {
      setImageLoading(true); // Loading başlat
      let file = event.target.files[0];
      const aspectRatio = 3 / 4;

      // HEIC formatını kontrol et ve dönüştür
      if (file.type === "image/heic" || file.name.toLowerCase().endsWith('.heic')) {
        try {
          const jpegBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8
          });
          file = new File([jpegBlob], file.name.replace('.heic', '.jpg'), {
            type: "image/jpeg"
          });
        } catch (error) {
          setImageLoading(false); // Hata durumunda loading'i kapat
          myToast({ 
            status: "error", 
            message: "HEIC formatı dönüştürülürken hata oluştu" 
          });
          return;
        }
      }

      // Desteklenen formatları kontrol et
      if (!file.type.startsWith('image/')) {
        setImageLoading(false); // Hata durumunda loading'i kapat
        myToast({ 
          status: "error", 
          message: "Lütfen geçerli bir resim dosyası seçin (JPEG, PNG, HEIC)" 
        });
        return;
      }

      setImage(file);

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const image = new Image();
        image.src = reader.result;

        image.onload = () => {
          const width = image.width;
          const height = image.height;
          const calculatedAspectRatio = width / height;

          if (calculatedAspectRatio !== aspectRatio) {
            setImageLoading(false); // Hata durumunda loading'i kapat
            myToast({
              status: "warn",
              message: "Resmin boyutları 3/4 boyutunda olmalıdır örn: 750*1000",
            });
          } else {
            // Resim sıkıştırma işlemi
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            const maxWidth = 750;
            const maxHeight = 1000;
            
            canvas.width = maxWidth;
            canvas.height = maxHeight;

            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(image, 0, 0, maxWidth, maxHeight);

            const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8);
            setImageBase64Data(compressedBase64);
            setImageLoading(false); // İşlem başarılı olduğunda loading'i kapat
          }
        };
      };
    } catch (error) {
      console.error(error);
      setImageLoading(false); // Hata durumunda loading'i kapat
      myToast({ status: "error", message: "Resim yüklenirken hata oluştu" });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={4}>
        {/* Sol Taraf - Resim Alanı */}
        <Grid item xs={12} md={4}>
          <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                paddingTop: '133.33%', // 3:4 aspect ratio
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 3,
                bgcolor: 'grey.100'
              }}
            >
              {imageLoading ? (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(255, 255, 255, 0.8)',
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box
                  component="img"
                  src={imageBase64Data || "https://placehold.co/750x1000"}
                  alt="Ürün Görseli"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              )}
            </Box>

            <input
              type="file"
              accept="image/jpeg, image/png, image/jpg, image/heic"
              ref={fileInputRef}
              onChange={handleFileUpload}
              hidden
            />

            <Button
              fullWidth
              variant="contained"
              startIcon={<AddPhotoIcon />}
              onClick={triggerFileInput}
              sx={{
                mt: 2,
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                  bgcolor: 'primary.dark',
                }
              }}
            >
              Resim Ekle
            </Button>

            <Alert severity="info" sx={{ mt: 2 }}>
              Resim boyutu 750x1000 px (3:4 oran) olmalıdır
            </Alert>
          </Box>
        </Grid>

        {/* Sağ Taraf - Form Alanı */}
        <Grid item xs={12} md={8}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Alert severity="info" sx={{ mb: 2 }}>
                  Ürün başlığı 20 karakterden uzun olmamalıdır
                </Alert>

                {/* Form alanları */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  <TextField
                    fullWidth
                    label="Ürün Adı"
                    value={productName || ''}
                    onChange={(e) => {
                      if (e.target.value.length <= 20) {
                        setProductName(e.target.value);
                      }
                    }}
                    size="small"
                  />

                  <TextField
                    fullWidth
                    label="Ürün Açıklaması"
                    value={productDescription || ''}
                    onChange={(e) => setProductDescription(e.target.value)}
                    multiline
                    rows={3}
                    size="small"
                  />

                  <TextField
                    fullWidth
                    type="number"
                    label="Kazanç Milyemi"
                    value={gainMilyem || ''}
                    onChange={(e) => setGainMilyem(e.target.value)}
                    size="small"
                  />

                  <TextField
                    fullWidth
                    type="number"
                    label="Gram"
                    value={productGram || ''}
                    onChange={(e) => setProductGram(e.target.value)}
                    size="small"
                  />

                  <TextField
                    select
                    fullWidth
                    label="Ana Kategori"
                    value={category || ''}
                    onChange={(e) => handleSelectCategory(e.target.value)}
                    size="small"
                  >
                    {categories.map((item) => (
                      <MenuItem key={item.categoryId} value={item}>
                        {item.categoryName}
                      </MenuItem>
                    ))}
                  </TextField>

                  {subCategories.length > 0 && (
                    <TextField
                      select
                      fullWidth
                      label="Alt Kategori"
                      value={selectedSubCategory || ''}
                      onChange={(e) => handleSelectSubCategory(e.target.value)}
                      size="small"
                    >
                      {subCategories.map((item) => (
                        <MenuItem key={item.subcategoryId} value={item}>
                          {item.subcategoryName}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}

                  <TextField
                    select
                    fullWidth
                    label="Ayar"
                    value={carat || ''}
                    onChange={(e) => setCarat(e.target.value)}
                    size="small"
                  >
                    {carats.map((item) => (
                      <MenuItem key={item.caratId} value={item.caratId}>
                        {item.caratName}
                      </MenuItem>
                    ))}
                  </TextField>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={visible}
                        onChange={() => setVisible(!visible)}
                        color="primary"
                      />
                    }
                    label="Görünür"
                  />
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Butonlar */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  <Button 
                    variant="outlined" 
                    color="error"
                    onClick={() => navigate('/products')}
                  >
                    İptal
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleSaveProduct}
                    disabled={savingProduct}
                    startIcon={savingProduct && <CircularProgress size={20} />}
                  >
                    {savingProduct ? 'Kaydediliyor...' : 'Kaydet'}
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Index;
